import { Box } from '@mui/material'

export const BaseIcon: React.FC<{ icon: string, onClick?: () => void }> = ({ icon, onClick = () => {} }) => {
  return (
    <Box component="img" src={icon} sx={{ maxWidth: '80px', cursor: 'pointer', borderRadius: '10px' }} onClick={onClick} />
  );
}
